import { render, staticRenderFns } from "./teaCourseFile.vue?vue&type=template&id=4b68108e&scoped=true"
import script from "./teaCourseFile.vue?vue&type=script&lang=js"
export * from "./teaCourseFile.vue?vue&type=script&lang=js"
import style0 from "./teaCourseFile.vue?vue&type=style&index=0&id=4b68108e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68108e",
  null
  
)

export default component.exports